// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"7437791c","208":"98293fce","412":"c7eafae7","453":"ed9e354e","511":"97f2d232","706":"10869569","711":"ab2d62d5","775":"2f715b11","827":"ca75218e"}[chunkId] + ".chunk.js";
};